"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessQuestionState = void 0;
const base_model_1 = __importDefault(require("./base-model"));
const defaults_1 = require("./defaults");
const question_1 = __importDefault(require("./question"));
var ProcessQuestionState;
(function (ProcessQuestionState) {
    ProcessQuestionState["INCOMPLETE"] = "INCOMPLETE";
    ProcessQuestionState["COMPLETE"] = "COMPLETE";
})(ProcessQuestionState = exports.ProcessQuestionState || (exports.ProcessQuestionState = {}));
class ProcessQuestion extends base_model_1.default {
    constructor(data = {
        id: null,
        name: null,
        order: null,
        question_set: null,
        next: null,
        previous: null,
        state: null
    }) {
        super(data);
        // Lowercase class name for normalization because JSCore uses base class name
        this.type = 'processquestions';
        this.name = defaults_1.defaultString(data.name);
        this.order = defaults_1.defaultNumber(data.order);
        this.questions = defaults_1.defaultArray(data.question_set).map((q) => new question_1.default(q));
        this.next = defaults_1.defaultString(data.next);
        this.previous = defaults_1.defaultString(data.previous);
        this.state = defaults_1.defaultEnum(data.state, ProcessQuestionState);
    }
    get completedCount() {
        return this.questions.filter((q) => q.answer).length;
    }
    get completed() {
        return this.state === ProcessQuestionState.COMPLETE;
    }
}
exports.default = ProcessQuestion;
